import React from "react";
import { Modal, Button } from "react-bootstrap";

const CancelModal = ({ show, onClose }) => (
    <Modal show={show} onHide={onClose}>
        <Modal.Header closeButton>
            <Modal.Title>Payment Cancelled</Modal.Title>
        </Modal.Header>
        <Modal.Body>Your transaction has been cancelled. You can try again anytime.</Modal.Body>
        <Modal.Footer>
            <Button variant="primary" onClick={onClose}>
                Close
            </Button>
        </Modal.Footer>
    </Modal>
);

export default CancelModal;
